import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils/global-utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap shrink-0 rounded-full ring-offset-white transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-40 ",
  {
    variants: {
      variant: {
        
        destructive: " bg-red-600 text-white hover:bg-red-300",
        plain:
          "text-black bg-white border-white border hover:border-neutral-200 hover:drop-shadow-md hover:text-lewk-primary focus:drop-shadow-md focus:text-lewk-primary",
        selected:
          "bg-black border text-white font-medium border-lewk-grey line-normal leading-tight tracking-[-0.32px] hover:text-lewk-primary ",

        primary:
          "bg-black text-white border font-medium border-lewk-grey line-normal leading-tight tracking-[-0.32px] hover:text-lewk-primary ",
        purple:
          "bg-lewk-primary text-white font-medium line-normal leading-tight tracking-[-0.32px] hover:opacity-50 ",
        secondary:
          "bg-white border font-medium border-lewk-grey line-normal leading-tight tracking-[-0.32px] hover:bg-black hover:text-lewk-primary ",
        outline: " hover:bg-black font-medium hover:text-lewk-primary line-normal leading-tight tracking-[-0.32px] "
      },
      size: {
        base: "w-30 h-10",
        sm: "h-8 px-4",
        lg: "h-11  px-8",
        icon: "h-10 w-10",
        full_w: "w-full h-10",
        "sidebar-icon": "size-12 p-2",
      },
    },
  }
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
